import React from 'react';

import { LocationOnboarding } from '@vyce/core/src/views/time/LocationOnboarding';

import { useActions, useTypedSelector } from '../../hooks';
import { getStaffRequest } from '@vyce/core/src/api/companies';

export const EmployerLocationOnboarding: React.FC = () => {
  const { selectedCompany } = useTypedSelector(state => state.helper);
  const { user } = useTypedSelector(state => state);
  const { fetchCompanyData } = useActions();

  return (
    <LocationOnboarding
      selectedCompany={selectedCompany}
      user={user}
      fetchCompanyData={fetchCompanyData}
      getStaffRequest={getStaffRequest}
    />
  );
};
